import React from 'react';
// import Helpers from './Helpers.js'

import './Notes.css';


class Notes extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
		}			
	}
		

	render() {
			return(
				<div className = 'Notes'>
					{						
							this.props.notes.map((v,i) => {
								return(
									<div className="NotesItem" key={i}>
                                        <b className='notesTitle'>{v.title} </b><span>{v.text}</span>
									</div>
								)
							})						
						}	
				</div>
			)


	}
}

export default Notes
